import { AcceptedContact } from '@ben/shared/utils/contacts';
import { sub } from 'date-fns';

export const getMaxDate = (
  contactType?: AcceptedContact,
  allowFutureDates?: boolean
): Date | undefined => {
  const today = new Date();
  if (allowFutureDates) {
    return undefined;
  }
  return !contactType || contactType === AcceptedContact.CHILD
    ? today
    : sub(today, {
        years: 16,
      });
};
